import axios from 'axios';
import {Message} from 'element-ui'
import Router from '@/router/index'

if(process.env.NODE_ENV!='development'){
  axios.defaults.baseURL="https://yzt-meeting.ysddong.com/";
  // axios.defaults.baseURL="https://yzt-meeting.ysddong.com/";
}


// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        data: params,
        traditional: true
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  let ctime = new Date().getTime();
  let logintime =  localStorage.getItem("logintime");
  let s = (ctime-logintime)/1000;
  if(s>10500 && logintime!='' && url.indexOf("sys/login")<0){
    Message.error({message: '登录超时，请重新登录', offset: 150});
    localStorage.setItem("userInfo", "");
    localStorage.setItem('logintoken', "")
    localStorage.setItem('logintime', "")
    // 缓存用户个人信息
    localStorage.setItem('userdata', "")
    Router.push({ path: '/login' })
    return;
  }else{
    localStorage.setItem('logintime',ctime)
  }
  params = params||{};
  //params['creator'] = JSON.parse(localStorage.getItem("userdata")).id;
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true
    }).then(res => {
      if(res.data.code==0 && res.data.msg=='TOKEN已失效'){
        Message.error({message: '登录超时，请重新登录', offset: 150});
        localStorage.setItem("userInfo", "");
        localStorage.setItem('logintoken', "")
        localStorage.setItem('logintime', "")
        // 缓存用户个人信息
        localStorage.setItem('userdata', "")
        Router.push({ path: '/login' })
      }else{
        localStorage.setItem('logintime', new Date().getTime())
      }
      return res.data;
    });
};

const reqFile = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': "multipart/form-data",
      token: localStorage.getItem('logintoken')
    },
    data: params
  }).then(res => res.data);
};

const importFile = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      // 'Content-Type': "multipart/form-data",
      token: localStorage.getItem('logintoken')
    },
    responseType: 'arraybuffer',
    data: params
  }).then(res =>  res.data);
};



export {
    loginreq,
    req,
    reqFile,
    importFile
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js